import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3733772"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-cy"]

import ToggleIcon from "@/components/svgs/toggleIcon.vue";
import { data } from "jquery";
import { PropType, nextTick, onMounted, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'baseCheckbox',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  text: {
    type: String as PropType<string>,
    default: "Checkbox",
  },
  ticked: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  disabled: {
    type: [String, Number, Boolean],
    default: false,
  },
  isDisabled: {
    type: [String, Number, Boolean],
    default: false,
  },
  textStyle: {
    type: String,
    default: "",
  },
  notYesNo: {
    type: Boolean,
    default: false,
  },
  textLeft: {
    type: String,
    default: "",
  },
  isCheckCursor: {
    type: Boolean,
    default: false,
  },
  dataCy: {
    type: String,
    default: "",
  },
  unSelectedColor: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
},
  emits: ["selected", "unselected", "onUpdate:ticked"],
  setup(__props, { emit: emits }) {

const props = __props;





onMounted(() => {
  nextTick(function () {
    if (props.ticked) {
      emitter(true);
    }
  });
});
const toggle = () => {
  if (props.notYesNo) {
    return;
  } else if (props.notYesNo === false && props.textLeft) {
    emitter(!props.ticked);
    return;
  } else if (props.disabled !== 1) {
    emitter(!props.ticked);
  }
};

const emitter = (value: boolean) => {
  if (value) {
    emits("selected");
  } else {
    emits("unselected");
  }
  emits("onUpdate:ticked", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["tw-flex tw-justify-center tw-items-center tw-gap-[10px] tw-w-[fit-content]", `${__props.isCheckCursor ? '' : 'tw-cursor-pointer'} tw-min-w-[20px]`]),
    "data-cy": __props.dataCy ? __props.dataCy : 'base-checkbox-option',
    onClick: toggle
  }, [
    _createVNode(ToggleIcon, {
      ticked: __props.ticked,
      color: __props.color,
      "un-selected-color": __props.unSelectedColor,
      class: _normalizeClass(`${__props.isCheckCursor ? '' : 'tw-cursor-pointer'} tw-min-w-[20px]`)
    }, null, 8, ["ticked", "color", "un-selected-color", "class"]),
    _createElementVNode("span", {
      class: _normalizeClass([
        'tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal] tw-select-none',
        __props.disabled ? '!tw-text-[#DBDBDB], tw-opacity-50 tw-cursor-wait' : '',
        __props.textLeft && __props.notYesNo ? '!tw-text-[#DBDBDB], tw-opacity-50' : '',
        __props.textLeft ? 'tw-opacity-100' : '',
        __props.textStyle,
      ]),
      style: _normalizeStyle(`${__props.textLeft && __props.notYesNo ? 'opacity: 0.5' : ''} ${
        __props.textLeft && !__props.notYesNo ? 'opacity: 1' : ''
      }`)
    }, _toDisplayString(__props.text), 7)
  ], 10, _hoisted_1))
}
}

})